import type { InquiryCommentTemplate } from '@/types/api';

import { ChevronRight } from 'lucide-react';
import { EmptyList, Controller } from '../reviews/ListTemplate';

import {
  LayoutTemplateContainer,
  LayoutTemplateContent,
  LayoutTemplateTitle,
} from '../../_layouts/LayoutsEditTemplate';

export interface ListTemplateProps {
  templateList: InquiryCommentTemplate[];
  onAdd: () => void;
  onEdit: (tpl: InquiryCommentTemplate) => void;
}

export const ListTemplate: React.FC<ListTemplateProps> = ({ templateList, onAdd, onEdit }) => {
  return (
    <LayoutTemplateContainer>
      <LayoutTemplateTitle>
        <div className="">템플릿 편집</div>
      </LayoutTemplateTitle>
      <LayoutTemplateContent>
        {templateList.length === 0 ? (
          <EmptyList />
        ) : (
          templateList.map((tpl) => <TemplateItem tpl={tpl} onClick={() => onEdit(tpl)} />)
        )}
      </LayoutTemplateContent>
      <Controller onAdd={onAdd} />
    </LayoutTemplateContainer>
  );
};

export const TemplateItem = ({
  tpl,
  onClick,
}: {
  tpl: InquiryCommentTemplate;
  onClick: (tpl: InquiryCommentTemplate) => void;
}) => {
  return (
    <button
      key={tpl.TemplateNo}
      className="flex h-[44px] w-full flex-shrink-0 cursor-pointer items-center justify-between rounded-[8px] text-gr-700 transition-all Body2M16 hover:bg-gr-50"
      onClick={() => onClick(tpl)}
    >
      <span>{tpl.Title}</span>
      <ChevronRight className="h-6 w-6" />
    </button>
  );
};
